module.exports = __webpack_public_path__ + "img/badge_platinum.8257270d.png";